<template>
  <div class="page-wrapper msg-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
      <div class="page-title text-upper-case">
        <h1>Members turning 65+</h1>
      </div>
      <pending-search @onSearch="searchData" @onClear="clearData" />
      <div class="table-card">
        <div
          class=" align-items-center top-pagination"
        >
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
        <simple-table :columns="columns">
          <template v-slot:tableBody>
            <pending-table :rows.sync="rows" :colSpan="columns.length" type="pendingMember65" />
          </template>
        </simple-table>
        <div
          class=" align-items-center"
        >
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import PendingTable from "./partials/PendingTable.vue";
import SimpleTable from "@/components/ui/SimpleTable.vue";
import PendingSearch from "./partials/PendingSearch.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
export default {
  components: { SimpleTable, PendingTable, PendingItemsInternal, PendingSearch },
  name: "PendingMember65List",
  data: () => ({
    rows: [],
    columns: [
      { label: "Member" },
      { label: "Turns 65" },
     // { label: "Termination Date" },
      { label: "Rep" },
      { label: "Group/Employer" },
      { label: "Plan(s)" },
      { label: "Action" },
    ],
    filters: { search: "" },
    breadcrumbItems: [{ title: "Member 65+", active: true }],
  }),
  methods: {
    clearData() {
      this.filters.search = "";
      this.getAll(this.filters);
    },
    searchData(query) {
      this.filters.search = query;
      this.getAll(this.filters);
    },
    getAll(filters = null) {
      let url;
      let loader = this.$loading.show();
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-pending-members-turning-65?${filterUrl}`;
      } else {
        url = `v2/get-pending-members-turning-65`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getAll(this.filters);
  },
};
</script>
<style src="@/assets/css/pending-details.css"></style>
